import { eventBus } from "@/services/event/eventBus";
import { useEffect, useState } from "react";
import { X } from "lucide-react";

type Notification = {
  id: number;
  message: string;
  type: "success" | "error";
};

export default function NotificationComponent() {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const removeNotification = (id: number) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  useEffect(() => {
    const unsubscribe = eventBus.on("notify", (event) => {
      const newNotification: Notification = {
        id: Date.now(),
        message: event.detail.message,
        type: event.detail.type,
      };

      setNotifications((prev) => [...prev, newNotification]);

      setTimeout(() => {
        setNotifications((prev) =>
          prev.filter((n) => n.id !== newNotification.id),
        );
      }, 5000);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-[100] space-y-2">
      {notifications.map((note) => (
        <div
          key={note.id}
          className={`relative flex items-center justify-between p-3 rounded shadow-lg ${
            note.type === "success" ? "bg-orange-500" : "bg-red-600"
          } text-white min-w-[300px]`}
        >
          <span className="pr-8">{note.message}</span>
          <button
            onClick={() => removeNotification(note.id)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/20"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
